"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsApi = void 0;
/* eslint-disable import/prefer-default-export */
var notificationsApi_1 = require("./notificationsApi");
Object.defineProperty(exports, "NotificationsApi", { enumerable: true, get: function () { return __importDefault(notificationsApi_1).default; } });
